import Widget from "lib/widget";
import { initBootstrapComponents } from "lib/bootstrapTooltips";

class DocumentUploadWidget extends Widget {
  bind() {
    this.checklistsRoot = this.root.find('#checklists-main-tab');
    this.updateItemRow = updateItemRow.bind(this)
    bindRemoveButton.call(this)
    bindRemoveButtonExternal.call(this)
  }
}

let bindRemoveButtonExternal = function () {
  const self = this

  this.checklistsRoot.on('click', '.remove-document-external', (e) => {
    let removalUrl = getOrBuildUrl.call(this, e)

    swal({
      title: "Are you sure you want to remove this document?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Sure`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: removalUrl,
          method: "PUT",
          dataType: "json"
        }).done((response) => {
          self.updateItemRow(response)
          window.location.reload()
        })
      }
    })
  })
}

let bindRemoveButton = function () {
  const self = this

  this.checklistsRoot.on('click', '.remove-document', (e) => {
    let removalUrl = getOrBuildUrl.call(this, e)

    swal({
      title: "Are you sure you want to remove this document?",
      text: 'This will revert the checklist item back to pending',
      type: "warning",
      showCancelButton: true,
      confirmButtonText: `Sure`,
    }).then((confirm) => {
      if (confirm.value === true) {
        $.ajax({
          url: removalUrl,
          method: "PUT",
          dataType: "json"
        }).done((response) => {
          self.updateItemRow(response)
        })
      }
    })
  })
}

// update item row
let updateItemRow = function (response) {
  let itemRow = this.checklistsRoot.find(`.checklist-item[data-item-id="${response.item.id}"]`)
  itemRow.replaceWith(response.item.html);
  initBootstrapComponents(this.checklistsRoot);
  this.root.find('#general-badge').html(response.project.outstanding_general_badge)
  this.root.find('#project-checklist-labels').html(response.project.checklist_labels)
  // External portal has no checklist progress bar, so the response does not have a `checklist`.
  if (response.checklist) {
    this.root.find(`#checklist-progress-${response.checklist.id}`).html(response.checklist.progress_bar_html)
  }
}

// this widget is shared with the external pages.
// For external pages we don't pass the url but the item id instead.
let getOrBuildUrl = function (e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  }
}

export default DocumentUploadWidget
